import axios from 'axios';
import END_POINT from '../config/endpoints.constants';
import { getErrorMessage } from '../customer-call-sdk/lib/API';
import { VriAPIResponse, VriAPIResult } from '../types';
import { MeetingUrlList, MeetingUrlSchema } from '../types/meeting-details';

export interface ParseExternalMeetingUrlResponse extends VriAPIResponse {
    data: {
        meetingUrlList: MeetingUrlList[];
    };
}

export interface ParseExternalMeetingUrlResult extends VriAPIResult {
    data?: MeetingUrlSchema;
}

export async function parseExternalMeetingUrl(
    meetingDetail: string,
): Promise<ParseExternalMeetingUrlResult> {
    const result: ParseExternalMeetingUrlResult = {};
    try {
        const { data: responseData } = await axios.post<ParseExternalMeetingUrlResponse>(
            END_POINT.PARSE_EXTERNAL_MEETING_URL,
            { meetingDetail },
        );
        if (responseData?.code === 1 || responseData?.code === 2) {
            result.error = responseData.message;
        } else if (
            responseData?.data?.meetingUrlList &&
            responseData?.data?.meetingUrlList.length > 0
        ) {
            result.data = responseData?.data?.meetingUrlList[0].schema;
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
}
